// Currencies action types
export const SET_PRODUCTSANDSERVICES_DATA = "SET_PRODUCTSANDSERVICES_DATA";
export const ADD_PRODUCTANDSERVICE = "ADD_PRODUCTANDSERVICE";
export const UPDATE_PRODUCTANDSERVICE = "UPDATE_PRODUCTANDSERVICE";
export const DELETE_PRODUCTANDSERVICE = "DELETE_PRODUCTANDSERVICE";
